import { render, staticRenderFns } from "./logs-modal.vue?vue&type=template&id=c8916f88"
import script from "./logs-modal.vue?vue&type=script&lang=ts"
export * from "./logs-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports